export class EventModal {
    constructor() {
        this.onClickTabEvent = () => {
            let elementMonthTab = document.querySelectorAll('input[name="event-month-tab"]');
            let elementShowModel = document.querySelector('dl[data-modal-open="modal-event"]');
            let loadingElement = document.querySelector('.panel-loading');
            for (let i = 0; i < elementMonthTab.length; i++) {
                elementMonthTab[i].addEventListener("change", function () {
                    loadingElement.style.display = 'block';
                    setTimeout(() => {
                        loadingElement.style.display = 'none';
                    }, 700);
                });
            }
            elementShowModel.addEventListener("click", function () {
                loadingElement.style.display = 'block';
                setTimeout(() => {
                    loadingElement.style.display = 'none';
                }, 700);
            });
        };
    }
}
export default new EventModal();
